import React, { } from 'react'

const ValidatedForm = ({ content, values, step, setStep }) => {

    const gotoStep = (e) => {
        e.preventDefault();
        setStep(step);
    }

    return (
        <div className="step-done">
            <div className="text-step">Steg {step} av 4</div>
            <div className="text-title">{content.heading}</div>
            {values.map(value => {
                return (
                    <div className="validated-values" key={value}>
                        <span className="checkmark">✓ </span><span >{value}</span>
                    </div>
                )
            })}
            <button className="form-button" onClick={gotoStep}>Ändra</button>

        </div>
    )
}

export default ValidatedForm
